import axios from "axios";
import React, { useState, useEffect } from "react";
import { baseUrl } from "../../../enum/constant";

const UpdateEmail = ({ setEmailTxt, setUserEmail }) => {
  const [newEmail, setNewEmail] = useState("");
  const [confirmEmail, setConfirmEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  useEffect(() => {
    const modal = document.getElementById("emailModal");

    modal.addEventListener("shown.bs.modal", () => {
      setError("");
      setSuccess("");
      setNewEmail("");
      setConfirmEmail("");
    });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    // Check if the new email and confirmation email match
    if (!newEmail || !confirmEmail) {
      setError("New email and confirmation email are required.");
      return;
    }
    if (newEmail !== confirmEmail) {
      setError("New email and confirmation email do not match.");
      return;
    }

    const data = {
      new_email: newEmail,
    };

    try {
      const token = localStorage.getItem("token");
      const base = baseUrl;
      const response = await axios.post(base + "api/update-email", data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      setSuccess(response.data.message);
      setNewEmail("");
      setConfirmEmail("");

      const [username, domain] = newEmail.split("@");
      const visiblePart = username.slice(-4);

      localStorage.setItem("email", newEmail);
      setUserEmail(newEmail);
      setEmailTxt(`${visiblePart}@${domain}`);
      document.getElementById("close-modal").click();

      // Hide success message after 30 seconds
      setTimeout(() => {
        setSuccess("");
      }, 3000); // 3 seconds
    } catch (error) {
      if (error.response) {
        setError(
          error.response.data.error ||
            error.response.data.message ||
            "An error occurred"
        );
      } else {
        setError("Network error");
      }
    }
  };

  return (
    <>
      {/* <!-- Email Modal --> */}
      <div className="modal fade" id="emailModal" tabindex="-1">
        <div className="modal-dialog">
          <div className="modal-content email-modal-cont p-3">
            <div className="modal-header border-0">
              <h5 className="modal-title">Change Email Address</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              >
                <img src="assets/images/cross.png	" />
              </button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="modal-body">
                <div className="mb-3">
                  <div className="box">
                    <label>New Email</label>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Enter new email"
                      value={newEmail}
                      onChange={(e) => setNewEmail(e.target.value)}
                      required
                    />
                  </div>
                </div>
                <div className="mb-3">
                  <div className="box">
                    <label>Confirm New Email</label>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Confirm new email"
                      value={confirmEmail}
                      onChange={(e) => setConfirmEmail(e.target.value)}
                      required
                    />
                  </div>
                </div>
                {error && <div className="alert alert-danger">{error}</div>}
                {success && (
                  <div className="alert alert-success">{success}</div>
                )}
              </div>
              <div className="modal-footer border-0">
                <button
                  type="submit"
                  className={`btn ${
                    !newEmail || !confirmEmail ? "btn-secondry" : "btn-primary"
                  } `}
                  disabled={!newEmail || !confirmEmail}
                >
                  Update
                </button>

                <button
                  type="button"
                  id="close-modal"
                  className="btn btn-cancel"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateEmail;
